<footer style="box-shadow: 0px -3px 8px rgba(0, 0, 0, 0.05);">
  <div class="container" style="padding: 0;">
    <div class="footer-menu">

      <!-- Shopping -->
      <div class="footer-item" routerLink="/Home">
        <span class="cart-icon">
          <img src="/assets/e-commerce/icons/62.webp" alt="" />
        </span>
        <p>{{ "shopping" | transloco }}</p>
      </div>

      <!-- Cart -->
      <div class="footer-item" routerLink="/cart">
        <span class="cart-icon">
          @if(cartCount > 0){
            <img src="/assets/e-commerce/icons/45.webp" alt="" />
          }
          @else{
            <img src="/assets/e-commerce/icons/44.webp" alt="" />
          }

          <span class="cart-badge" *ngIf="cartCount > 0">
            {{ cartCount }}
          </span>
        </span>
        <p>{{ "Cart" | transloco }}</p>
      </div>

      <!-- My Clinic Services OR My Orders -->
      @if(isClinicRoute) {
        <div class="footer-item" routerLink="/myclinicservices">
          <span class="cart-icon">
            <img src="/assets/e-commerce/icons/95.webp" alt="{{ 'myclinicservices' | transloco }}" />
          </span>
          <p>{{ "myclinicservices" | transloco }}</p>
        </div>
      } @else {
        <div class="footer-item" routerLink="/Myorders">
          <span class="cart-icon">
            <img src="/assets/e-commerce/icons/50.webp" alt="{{ 'myorders' | transloco }}" />
          </span>
          <p>{{ "myorders" | transloco }}</p>
        </div>
      }

      <!-- Clinic -->
      <div class="footer-item" routerLink="/clinic">
        <span class="cart-icon">
          <img src="/assets/e-commerce/icons/93.webp" alt="{{ 'clinic' | transloco }}" />
        </span>
        <p>{{ "clinic" | transloco }}</p>
      </div>

      <!-- Profile / Login -->
      @if(tokenExists){
        <div class="footer-item" routerLink="/Profile">
          <span class="cart-icon">
            <img src="/assets/e-commerce/icons/48.webp" alt="" />
          </span>
          <p>{{ "Profile" | transloco }}</p>
        </div>
      }
      @else{
        <div class="footer-item" routerLink="/Login">
          <span class="cart-icon">
            <img src="/assets/e-commerce/icons/49.webp" alt="" />
          </span>
          <p>{{ "Log in" | transloco }}</p>
        </div>
      }

    </div>
  </div>
</footer>